import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-number-input',
  templateUrl: './number-input.component.html',
  styleUrl: './number-input.component.scss'
})
export class NumberInputComponent {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Input() showLabel: boolean = true;
  @Output() valueChange = new EventEmitter<string>();
  @Output() isFieldInvalid = new EventEmitter<boolean>();

  updateValue(value: string) {
    const isValidNumber = this.isValidNumber(value);
    if (!isValidNumber) {
      this.error = true;
      this.errorText = 'Please enter a valid number.';
      this.isFieldInvalid.emit(true);
    } else {
      this.error = false;
      this.errorText = 'This field is required.';
      this.value = value;
      this.valueChange.emit(value);
      this.isFieldInvalid.emit(false);
    }
  }

  isValidNumber(value: string) {
    // This regex checks for an optional leading sign, digits, optional decimal, and optional digits after the decimal.
    const regex = /^\d*(\.\d+)?$/;
    return regex.test(value);
  }
}